/* eslint-disable @typescript-eslint/no-var-requires */
// eslint-disable-next-line no-undef
define(function (require, exports, module) {
  function a(a, b) {
    var c = require('./aes'),
      d = c.enc.Utf8.parse(a),
      e = c.enc.Utf8.parse(b),
      f = c.enc.Utf8.parse(a),
      g = c.AES.encrypt(e, d, { iv: f, mode: c.mode.CBC })
    return g.toString()
  }
  function b(a, b) {
    var c = require('./aes'),
      d = c.enc.Utf8.parse(a),
      e = c.enc.Utf8.parse(a),
      f = c.enc.Base64.parse(b),
      g = c.AES.decrypt({ ciphertext: f }, d, { iv: e, mode: c.mode.CBC })
    return g.toString(c.enc.Utf8)
  }
  function c(a, b) {
    var c = require('./des'),
      d = c.enc.Utf8.parse(a),
      e = c.enc.Utf8.parse(b),
      f = c.DES.encrypt(e, d, { mode: c.mode.ECB, padding: c.pad.Pkcs7 })
    return f.toString()
  }
  function d(a, b) {
    var c = require('./des'),
      d = c.enc.Utf8.parse(a),
      e = c.enc.Base64.parse(b),
      f = c.DES.decrypt({ ciphertext: e }, d, { mode: c.mode.ECB, padding: c.pad.Pkcs7 })
    return f.toString(c.enc.Utf8)
  }
  function e(a, b, c) {
    ;(a && b) || console.log('加密模块modulus或者公钥publicExponent为空！')
    var d = require('./rsa')
    // return d.setPublic(a, b), 'encrypt_rsa:' + d.encrypt(c)
    return d.setPublic(a, b), d.encrypt(c)
  }
  var f = { aesEncrypt: a, aesDecrypt: b, desEncrypt: c, desDecrypt: d, rsaEncrypt: e }
  module.exports = f
})
